import { render, staticRenderFns } from "./RemindDetail.vue?vue&type=template&id=baf4e07a&scoped=true&"
import script from "./RemindDetail.vue?vue&type=script&lang=js&"
export * from "./RemindDetail.vue?vue&type=script&lang=js&"
import style0 from "./RemindDetail.vue?vue&type=style&index=0&id=baf4e07a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf4e07a",
  null
  
)

export default component.exports